<div class="file-card" [class.file-card--user]="variant() === 'user'">
  <span class="file-card-icon">
    <i class="myre-icon-file"></i>
  </span>

  <div class="file-card-body">
    <span class="file-card-name">{{ fileName() }}</span>
    @if (fileMeta()) {
      <span class="file-card-meta">{{ fileMeta() }}</span>
    }
  </div>

  <button
    class="file-card-download"
    type="button"
    [attr.aria-label]="chatWordings.attachment()"
    (click)="download.emit()"
  >
    <i class="myre-icon-download"></i>
  </button>
</div>
